var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChevronleftIco(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7352 7.00031C13.5404 7.00599 13.3555 7.08724 13.2196 7.22687L9.21958 11.2269C9.07898 11.3675 9 11.5583 9 11.7571C9 11.956 9.07898 12.1468 9.21958 12.2874L13.2196 16.2874C13.2887 16.3594 13.3715 16.4169 13.4631 16.4565C13.5547 16.496 13.6532 16.5169 13.753 16.518C13.8528 16.519 13.9518 16.5001 14.0442 16.4624C14.1365 16.4246 14.2205 16.3689 14.291 16.2983C14.3616 16.2278 14.4174 16.1438 14.4551 16.0514C14.4928 15.9591 14.5117 15.8601 14.5107 15.7603C14.5097 15.6605 14.4887 15.5619 14.4492 15.4704C14.4096 15.3788 14.3521 15.296 14.2801 15.2269L10.8104 11.7571L14.2801 8.28742C14.3883 8.18204 14.4622 8.04646 14.4921 7.8984C14.5219 7.75035 14.5064 7.59673 14.4475 7.45764C14.3886 7.31856 14.2891 7.20049 14.162 7.11889C14.035 7.03729 13.8862 6.99596 13.7352 7.00031Z",
    fill: "#0A0A0A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronleftIco);
export default __webpack_public_path__ + "static/media/chevronleft-ico.32df2876.svg";
export { ForwardRef as ReactComponent };